const CLOUDINARY_BASE_URL_1X =
    'https://fiverr-res.cloudinary.com/image/upload/q_auto,f_auto/v1/attachments/generic_asset/asset';
const CLOUDINARY_BASE_URL_2X =
    'https://fiverr-res.cloudinary.com/image/upload/q_auto,f_auto/v1/attachments/generic_asset/asset';

export const IMAGES = {
    MOCKUP: {
        imgUrl: `${CLOUDINARY_BASE_URL_1X}/98132cd7f4bf84a521dc14d14520e906-1638522706340/Mockup_brief.png`,
        srcSet: {
            '1x': `${CLOUDINARY_BASE_URL_1X}/98132cd7f4bf84a521dc14d14520e906-1638522706340/Mockup_brief.png`,
            '2x': `${CLOUDINARY_BASE_URL_2X}/d5ec27f117931863a5cb47a47e683258-1638522774185/Mockup_brief_2x.png`,
        },
    },
    BACKGROUND: {
        imgUrl: `${CLOUDINARY_BASE_URL_1X}/e7a727c244535eca4ca6627f1cde38af-1642082670215/Static_listing_background.png`,
        srcSet: {
            '1x': `${CLOUDINARY_BASE_URL_1X}/e7a727c244535eca4ca6627f1cde38af-1642082670215/Static_listing_background.png`,
            '2x': `${CLOUDINARY_BASE_URL_2X}/e7a727c244535eca4ca6627f1cde38af-1642082670217/Static_listing_background_2x.png`,
        },
    },
};
